<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Action Details</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="actionCopy">
    <ion-item>
        <ion-label position="floating">Assigned to</ion-label>
        <ion-select [(ngModel)]="actionCopy.actor" interface="popover">
            <ion-select-option *ngFor="let operator of operators"
                               [value]="operator.cod">{{operator.username}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-label position="floating">Priority</ion-label>
        <ion-select [(ngModel)]="actionCopy.action_priority_id" interface="popover">
            <ion-select-option *ngFor="let priority of actionPriorities"
                               [value]="priority.id">{{priority.description}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-label position="floating">Action Type</ion-label>
        <ion-select [(ngModel)]="actionCopy.action_type_id" interface="popover">
            <ion-select-option *ngFor="let type of actionTypes"
                               [value]="type.id">{{type.description}}</ion-select-option>
        </ion-select>
    </ion-item>

    <ion-item *ngIf="!newCustomer">
        <ion-label *ngIf="!actionCopy.customerDTO.name" (click)="searchCustomer()">Select Customer</ion-label>
        <ion-text *ngIf="actionCopy.customerDTO.name"
                  (click)="searchCustomer()">{{actionCopy.customerDTO.name}}</ion-text>
        <ion-icon name="add" slot="end" *ngIf="!actionCopy.customerDTO.name"
                  (click)="newCustomer = true; newContact = true; processNewCustomerNewContact()"></ion-icon>
        <ion-icon name="close" slot="end" *ngIf="actionCopy.customerDTO.name" (click)="clearCustomer()"></ion-icon>
        <ion-icon name="search" slot="end" (click)="searchCustomer()"></ion-icon>
    </ion-item>

    <ion-card *ngIf="newCustomer">
        <ion-fab vertical="center" horizontal="end" >
            <ion-fab-button (tap)="newCustomer = false; newContact = false" size="small" color="light">
                <ion-icon name="close"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <ion-input type="text" placeholder="Customer/company name..."
                   [(ngModel)]="actionCopy.customerDTO.name" (ionChange)="updateContactName($event)"></ion-input>
        <ion-input type="text" placeholder="Address 1" [(ngModel)]="actionCopy.customerDTO.add1"></ion-input>
        <ion-input type="text" placeholder="Address 2" [(ngModel)]="actionCopy.customerDTO.add2"></ion-input>
        <ion-input type="text" placeholder="Address 3" [(ngModel)]="actionCopy.customerDTO.add3"></ion-input>
        <ion-input type="text" placeholder="Address 4" [(ngModel)]="actionCopy.customerDTO.add4"></ion-input>
    </ion-card>

    <ion-item *ngIf="!newContact && !newCustomer">
        <ion-label (click)="searchContact()" *ngIf="!actionCopy.contactDTO.name">Select Contact</ion-label>
        <ion-grid *ngIf="actionCopy.contactDTO.name">
            <ion-row class="ion-no-padding ion-no-margin">
                <ion-col size="9" class="ion-no-padding ion-no-margin">
                    {{ actionCopy.contactDTO.name }}
                </ion-col>
            </ion-row>
            <ion-row class="ion-align-items-center ion-no-padding ion-no-margin" *ngIf="actionCopy.contactDTO.phone">
                <ion-col size="6" class="ion-no-padding ion-no-margin">
                    {{ actionCopy.contactDTO.phone }}
                </ion-col>
                <ion-col size="3" *ngIf="actionCopy.contactDTO.phone" class="ion-no-padding ion-no-margin">
                    <ion-chip (click)="callContact.callContact(actionCopy.contactDTO.phone)" class="ion-float-right"
                              color="success">
                        Call
                        <ion-icon name="call"></ion-icon>
                    </ion-chip>
                </ion-col>
            </ion-row>
            <ion-row class="ion-no-padding ion-no-margin" *ngIf="actionCopy.contactDTO.email">
                <!--TODO Send email when clicking-->
                <ion-col size="9" class="ion-no-padding ion-no-margin">
                    {{ actionCopy.contactDTO.email }}
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-icon name="add" slot="end" *ngIf="actionCopy.customerDTO.name" (click)="newContact = true; processNewCustomerNewContact()"></ion-icon>
        <ion-icon name="search" slot="end" (click)="searchContact()"></ion-icon>
    </ion-item>

    <ion-card *ngIf="newContact || newCustomer">
        <ion-fab vertical="center" horizontal="end" 
                 *ngIf="actionCopy.customerDTO && actionCopy.customerDTO.cod">
            <ion-fab-button (tap)="newContact = false" size="small" color="light">
                <ion-icon name="close"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <ion-input type="text" placeholder="Contact name" [(ngModel)]="actionCopy.contactDTO.name"
                   maxlength="20"></ion-input>
        <ion-input type="tel" placeholder="Phone" [(ngModel)]="actionCopy.contactDTO.phone"></ion-input>
        <ion-input type="email" placeholder="Email" [(ngModel)]="actionCopy.contactDTO.email"></ion-input>
    </ion-card>

    <ion-item (click)="selectDate()" *ngIf="!actionCopy.date_completed && actionCopy.id > 0">
        <ion-label>New Scheduled Date:</ion-label>
        <ion-label class="ion-text-end">{{ actionCopy.date_scheduled | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
        <ion-icon slot="end" name="calendar"></ion-icon>
    </ion-item>
    <ion-item (click)="selectDate()" *ngIf="!actionCopy.date_completed && actionCopy.id === 0 ">
        <ion-label>Scheduled Date:</ion-label>
        <ion-label class="ion-text-end">{{ actionCopy.date_scheduled | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
        <ion-icon slot="end" name="calendar"></ion-icon>
    </ion-item>
    <ion-item class="ion-text-center" *ngIf="actionCopy.date_completed">
        <ion-label>Completed: {{actionCopy.date_completed | date: 'dd/MM/yyyy HH:mm'}}</ion-label>
        <ion-icon slot="end" name="calendar"></ion-icon>
    </ion-item>
    <ion-item>
        <ion-textarea auto-grow [(ngModel)]="actionCopy.comment"></ion-textarea>
        <ion-button (tap)="addTimestamp()" color="light" size="small">
            <ion-icon name="stopwatch" slot="icon-only"></ion-icon>
        </ion-button>
    </ion-item>

    <!--    <ion-item>-->
    <!--        <ion-checkbox slot="start"></ion-checkbox>-->
    <!--        <ion-textarea auto-grow [(ngModel)]="actionCopy.comment"></ion-textarea>-->
    <!--        <ion-button (tap)="addTimestamp()" color="light" size="small">-->
    <!--            <ion-icon name="stopwatch" slot="icon-only"></ion-icon>-->
    <!--        </ion-button>-->
    <!--    </ion-item>-->
    <!--    <ion-button (tap)="addTask()" color="light" shape="round" expand="full">-->
    <!--        Create/Add Sub actionCopy-->
    <!--        <ion-icon name="add"></ion-icon>-->
    <!--    </ion-button>-->

    <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button (tap)="saveAction()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>

<ion-footer *ngIf="actionCopy && actionCopy.id !== 0">
    <ion-label>
        Created by: {{actionCopy.creatorName}} on: {{actionCopy.date_created | date: "dd/MM/yyyy HH:mm"}}
    </ion-label>
</ion-footer>
